import { render, staticRenderFns } from "./monthTest.vue?vue&type=template&id=0a1842f4&scoped=true&"
import script from "./monthTest.vue?vue&type=script&lang=js&"
export * from "./monthTest.vue?vue&type=script&lang=js&"
import style0 from "./monthTest.vue?vue&type=style&index=0&id=0a1842f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1842f4",
  null
  
)

export default component.exports